<template>
  <div>
    <header class="header_area  fixed-top">
      <div class="container-fluid">
          <div class="row">
              <div class="col-md-12">
                  <div class="header_main_wrap">
                      <div class="header_left">
                        <button
                          v-if="isCompactViewport"
                          type="button"
                          class="mobile_nav_toggle"
                          aria-label="Toggle navigation"
                          @click="$emit('toggleSidebar')"
                        >
                          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <path d="M4 7H20" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                            <path d="M4 12H20" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                            <path d="M4 17H14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                          </svg>
                        </button>
                        <div class="logo mt_5">
                          <router-link :to="{name: 'dashboard'}">
<!--                            <img src="@/assets/media/images/logo.png" alt="">-->
                            <span v-if="isCompactViewport" class="mobile_brand">Antel</span>
                          </router-link>
                        </div>
                      </div>
                      <div class="header_right_menu">
                        <ul>
                            <li class="header_userx">
                              <div class="header_list_btnx">
                                <div class="">
                                  <button type="button" class="btn dropdown-toggle no_arrow" data-bs-toggle="dropdown" aria-expanded="false">
                                    <svg viewBox="0 0 20 20" height="24" width="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Zm3-14a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm1.368 10c.342 0 .632-.259.632-.6 0-2.982-2.239-5.4-5-5.4s-5 2.418-5 5.4c0 .341.29.6.632.6h8.736Z" fill-rule="evenodd" fill="currentColor"></path></svg>
                                  </button>
                                  <ul class="dropdown-menu dropdown-menu-end width_150p">
                                    <li>
                                      <router-link :to="{ name: 'manage_account', params: { slug: 'my-account' } }">
                                        <button class="dropdown-item" type="button">My Account</button>
                                      </router-link>
                                    </li>
                                    <li @click.prevent="logout">
                                      <button class="dropdown-item logout_btn" type="button">Log out</button>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </li>
                        </ul>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </header>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import router from "@/routes";

export default {
  emits: ['toggleSidebar'],
  props: {
    isCompactViewport: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE,
    }
  },
  computed: {
    ...mapGetters({
      customer: 'auth/getUserInfo',
      services: 'auth/getCustomerServices',
    }),
  },

  methods: {
    reload(name){
      if(this.$route.name === name){
        this.$store.commit('setReload', true)
      }
    },
    logout() {
      this.axios.post('/logout').finally(() => {
        this.$store.dispatch('auth/logout')
        this.$router.push({name: 'login'})
      })
    },
  },
  beforeUnmount() {
  },
}
</script>

<style scoped>

</style>
